export default __webpack_public_path__ + "static/media/dropdown-arrow.c381148f.svg";